module.exports = __webpack_public_path__ + "assets/media/chat.5b33dfe5.mp3";